export default __webpack_public_path__ + "static/media/dungeonmaintence.9adb9e2b.gif";